import axios from 'axios';

// API URL - should be from environment or config
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:4000';

export default {
  namespaced: true,
    state: {
    items: [], // danh sách tri thức phân trang
    pagination: { },
    loading: false,
    showForm: false,
    isEditing: false,
    saving: false,
    contentError: '',
    knowledgeForm: {
      id: null,
      title: '',
      content: '',
      category: ''
    },
    searchQuery: '',
    showDeleteConfirm: false,
    itemToDelete: null,
    deleting: false,
    showViewModal: false,
    currentViewItem: null
  },

  getters: {
    filteredKnowledgeItems: (state) => {
      if (!state.searchQuery.trim()) {
        return state.items;
      }
      const query = state.searchQuery.toLowerCase();
      return state.items.filter(item =>
        (item.title && item.title.toLowerCase().includes(query)) ||
        item.content.toLowerCase().includes(query) ||
        (item.category && item.category.toLowerCase().includes(query))
      );
    }
  },
    mutations: {
    SET_KNOWLEDGE_ITEMS(state, items) {
      state.items = items;
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_SHOW_FORM(state, status) {
      state.showForm = status;
    },
    SET_IS_EDITING(state, status) {
      state.isEditing = status;
    },
    SET_SAVING(state, status) {
      state.saving = status;
    },
    SET_CONTENT_ERROR(state, message) {
      state.contentError = message;
    },
    SET_KNOWLEDGE_FORM(state, form) {
      state.knowledgeForm = form;
    },
    SET_SEARCH_QUERY(state, query) {
      state.searchQuery = query;
    },
    SET_SHOW_DELETE_CONFIRM(state, status) {
      state.showDeleteConfirm = status;
    },
    SET_ITEM_TO_DELETE(state, item) {
      state.itemToDelete = item;
    },
    SET_DELETING(state, status) {
      state.deleting = status;
    },
    SET_SHOW_VIEW_MODAL(state, status) {
      state.showViewModal = status;
    },
    SET_CURRENT_VIEW_ITEM(state, item) {
      state.currentViewItem = item;
    }
  },
  
  actions: {
    async fetchKnowledgeItems({ commit, dispatch }, { page = 1, limit = 10, category } = {}) {
      commit('SET_LOADING', true);
      try {
        const params = { page, limit };
        if (category) params.category = category;
        const response = await axios.get(`${API_URL}/api/knowledge`, { params });
        commit('SET_KNOWLEDGE_ITEMS', response.data.items || []);
        commit('SET_PAGINATION', response.data.pagination || { page, limit, pages: 1, total: 0 });
      } catch (error) {
        console.error('Failed to fetch knowledge items:', error);
        dispatch('notification/showNotification', {
          type: 'error',
          message: 'Failed to load knowledge base'
        }, { root: true });
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    openCreateForm({ commit }) {
      commit('SET_IS_EDITING', false);
      commit('SET_KNOWLEDGE_FORM', {
        id: null,
        title: '',
        content: '',
        category: ''
      });
      commit('SET_CONTENT_ERROR', '');
      commit('SET_SHOW_FORM', true);
    },
    
    editKnowledgeItem({ commit }, item) {
      commit('SET_IS_EDITING', true);
      commit('SET_KNOWLEDGE_FORM', {
        id: item.id,
        title: item.title || '',
        content: item.content,
        category: item.category || ''
      });
      commit('SET_CONTENT_ERROR', '');
      commit('SET_SHOW_FORM', true);
    },
    
    closeForm({ commit }) {
      commit('SET_SHOW_FORM', false);
    },
    
    async saveKnowledgeItem({ commit, state, dispatch }) {
      // Validate
      if (!state.knowledgeForm.content.trim()) {
        commit('SET_CONTENT_ERROR', 'Content is required');
        return;
      }
      
      commit('SET_SAVING', true);
      
      try {
        const payload = {
          title: state.knowledgeForm.title,
          content: state.knowledgeForm.content,
          category: state.knowledgeForm.category || 'zalo'
        };
        if (state.isEditing) {
          // Update existing item
          await axios.put(`${API_URL}/api/knowledge/${state.knowledgeForm.id}`, payload);
          
          dispatch('notification/showNotification', {
            type: 'success',
            message: 'Knowledge item updated successfully'
          }, { root: true });
        } else {
          // Create new item
          await axios.post(`${API_URL}/api/knowledge`, payload);
          
          dispatch('notification/showNotification', {
            type: 'success',
            message: 'Knowledge item created successfully'
          }, { root: true });
        }
        
        // Close form and refresh list
        dispatch('closeForm');
        dispatch('fetchKnowledgeItems');
      } catch (error) {
        console.error('Failed to save knowledge item:', error);
        dispatch('notification/showNotification', {
          type: 'error',
          message: 'Failed to save knowledge item'
        }, { root: true });
      } finally {
        commit('SET_SAVING', false);
      }
    },
    
    confirmDelete({ commit }, item) {
      commit('SET_ITEM_TO_DELETE', item);
      commit('SET_SHOW_DELETE_CONFIRM', true);
    },
    
    cancelDelete({ commit }) {
      commit('SET_ITEM_TO_DELETE', null);
      commit('SET_SHOW_DELETE_CONFIRM', false);
    },
    
    async deleteKnowledgeItem({ commit, state, dispatch }) {
      if (!state.itemToDelete) return;
      
      commit('SET_DELETING', true);
      
      try {
        await axios.delete(`${API_URL}/api/knowledge/${state.itemToDelete.id}`);
        
        dispatch('notification/showNotification', {
          type: 'success',
          message: 'Knowledge item deleted successfully'
        }, { root: true });
        
        // Close modal and refresh list
        dispatch('cancelDelete');
        dispatch('fetchKnowledgeItems');
      } catch (error) {
        console.error('Failed to delete knowledge item:', error);
        dispatch('notification/showNotification', {
          type: 'error',
          message: 'Failed to delete knowledge item'
        }, { root: true });
      } finally {
        commit('SET_DELETING', false);
      }
    },
      updateSearchQuery({ commit }, query) {
      commit('SET_SEARCH_QUERY', query);
    },
    
    viewKnowledgeItem({ commit }, item) {
      commit('SET_CURRENT_VIEW_ITEM', item);
      commit('SET_SHOW_VIEW_MODAL', true);
    },
    
    closeViewModal({ commit }) {
      commit('SET_SHOW_VIEW_MODAL', false);
      commit('SET_CURRENT_VIEW_ITEM', null);
    }
  }
};
